define(
({
  "select_shipping_method": "Wybierz metodę wysyłki"
})
);
